module.exports = __webpack_public_path__ + "images/category_lp/pc/customer3_ddca724af026a734f67cf1e4337e4512.jpg";